// The signed-in user, kept for the life of the tab so Desk can start with no connection.
//
// A reload during an outage cannot ask /auth/me who is signed in, and used to treat that failed
// read as a rejected token: it cleared the token and sent the user to /login, which also cannot
// load. The cache lives in sessionStorage next to the access token, so it ends with the tab just
// as the token does. It holds what /auth/me already answered, nothing more.

const ME_CACHE_KEY = "cos.me.cache";

export function writeCachedMe(user: unknown): void {
	try {
		sessionStorage.setItem(ME_CACHE_KEY, JSON.stringify(user));
	} catch {
		/* storage unavailable: the next reload simply has no cached user */
	}
}

export function readCachedMe<T>(): T | null {
	try {
		const raw = sessionStorage.getItem(ME_CACHE_KEY);
		return raw ? (JSON.parse(raw) as T) : null;
	} catch {
		return null;
	}
}

export function clearCachedMe(): void {
	try {
		sessionStorage.removeItem(ME_CACHE_KEY);
	} catch {
		/* nothing to clear */
	}
}

/** The request never got an answer (offline, DNS, a dropped connection): fetch rejected, so there
 *  is no HTTP status at all. A rejected token is an answer, and is not this. */
export function isConnectionFailure(err: unknown): boolean {
	return !(typeof err === "object" && err !== null && "status" in err);
}
